module.exports = __webpack_public_path__ + "img/vertical_4_5_2.3b640c7b.png";